import { postCodeAxios } from '@/plugins/axios'
import format from 'string-format'

const postCodeLink = 'postcodes/{postalCode}'

export const getPostCodeJp = ({ postalCode, params }) =>
  postCodeAxios.get(format(postCodeLink, { postalCode }), { params })

export const getAddress = async ({ postalCode }) => {
  const res = await getPostCodeJp({ postalCode, params: { apikey: process.env.VUE_APP_POST_CODE_JP_KEY } })
  const data = res.data

  return {
    prefecture: data[0].pref,
    municipality: `${data[0].city ?? ''}${data[0].town ?? ''}`,
    addr02: '',
  }
}
